import PropTypes from 'prop-types';
import authService from '../../services/AuthService';

const HasFeature = ({ feature, children = null, fallback = null }) => {
  if (!children) return null;
  if (!authService.hasFeature(feature)) {
    return fallback;
  }
  return children;
};

HasFeature.propTypes = {
  feature: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.node,
  fallback: PropTypes.node,
};
export default HasFeature;
